import { Button } from "react-bootstrap"
import { useNavigate } from "react-router"

import useT from "utils/hooks/useT"

import "./index.scss"

export default function HelpButton({ area, className, title }) {
  const navigate = useNavigate()
  const { t } = useT("common")
  const buttonClass = className ? `HelpButton ${className}` : "HelpButton"
  return (
    <Button
      variant="primary"
      className={buttonClass}
      onClick={() => navigate(`/help/${area}`)}
      title={title || t("help")}
    >
      ?
    </Button>
  )
}
